import { isEqual, isNullOrBlank, OptionsGetOne, optionsGetOneDefault, toJson } from '../../Commons';
import { ScriptEntity } from '../../Entities/Script.Entity';
import { SmartDBApi } from '../index.exports';
import { fetchWrapper } from '../../lib/index.exports';

export class ScriptApi extends SmartDBApi {
    protected static _Entity = ScriptEntity;

    // #region api

    public static async getByHashApi<T extends ScriptEntity>(hash: string, optionsGet?: OptionsGetOne): Promise<T | undefined> {
        try {
            if (isNullOrBlank(hash)) {
                throw `Script Hash not defined`;
            }
            //-------------------------
            let response;
            if (isEqual(optionsGet, optionsGetOneDefault)) {
                response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/by-hash/${hash}`);
            } else {
                const body = toJson(optionsGet);
                //-------------------------
                response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/by-hash/${hash}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - getByHashApi - response OK`);
                const instance = this._Entity.fromPlainObject<T>(data);
                console.log(`[${this._Entity.className()}] - getByHashApi - hash: ${hash} - Instance: ${instance.show()}`);
                return instance;
            } else if (response.status === 404) {
                console.log(`[${this._Entity.className()}] - getByHashApi - hash: ${hash} - Instance not found`);
                return undefined;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        } catch (error) {
            console.log(`[${this._Entity.className()}] - getByHashApi - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api
}
